import React, { useEffect, useState } from "react";
import "./styles/BhpAdBanner.css";
import { AdvertisingDetailsType } from "../types/data_types";
import {
  convertImgJsonToObj,
  fetchImgThumbnailData,
} from "../common/commonFunctions";
import "./../components/styles/ImageRotateStyle.css";
import { IonBackButton, IonButton } from "@ionic/react";
import AlertWithExec from "../UI/AlertWithExec";

const BhpSerratedCircle: React.FC<{
  radius?: number;
  textSize?: number;
  text?: string;
  idx: number;
  gradient: { colorA: string; colorB: string };
}> = (props) => {
  const radius = props?.radius ? props.radius : 30;
  const textSize = props?.textSize ? props.textSize : 35;
  const text = props?.text ? props.text : "%";

  const createSerratedPath = () => {
    const paths = [];
    const centerX = 50;
    const centerY = 50;
    const outerRadius = radius + 10;
    const steps = 24;
    const stepAngle = (2 * Math.PI) / steps;

    for (let i = 0; i < steps; i++) {
      const angle1 = i * stepAngle;
      const angle2 = (i + 1) * stepAngle;
      const angleMid = angle1 + stepAngle / 2;

      const x1 = centerX + radius * Math.cos(angle1);
      const y1 = centerY + radius * Math.sin(angle1);
      const x2 = centerX + outerRadius * Math.cos(angleMid);
      const y2 = centerY + outerRadius * Math.sin(angleMid);
      const x3 = centerX + radius * Math.cos(angle2);
      const y3 = centerY + radius * Math.sin(angle2);

      paths.push(`M${x1},${y1} L${x2},${y2} L${x3},${y3} Z`);
    }

    return paths.join(" ");
  };

  const circleDiameter = radius * 2;
  const textX = 50;
  const textY = 50 + textSize / 3; // Adjust the vertical position of the text

  const gradientId = `gradient-${props.idx}`;

  return (
    <div
      style={{ width: `${circleDiameter}px`, height: `${circleDiameter}px` }}
    >
      <svg width="100%" height="100%" viewBox="0 0 100 100">
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop
              offset="0%"
              style={{ stopColor: props.gradient.colorA, stopOpacity: 1 }}
            />
            <stop
              offset="100%"
              style={{ stopColor: props.gradient.colorB, stopOpacity: 1 }}
            />
          </linearGradient>
        </defs>
        <circle
          cx="50"
          cy="50"
          r={radius}
          fill={`url(#${gradientId})`}
          stroke={`url(#${gradientId})`}
        />
        <path d={createSerratedPath()} fill={`url(#${gradientId})`} />
        <text
          x={textX}
          y={textY}
          fill="white"
          fontSize={textSize}
          fontFamily="Arial"
          fontWeight="bold"
          textAnchor="middle"
        >
          {text}
        </text>
      </svg>
    </div>
  );
};

const BhpAdBanner: React.FC<{
  idx: number;
  adData: AdvertisingDetailsType;
  logoImgData: string;
  onClick?: () => void | Promise<void>;
  noRotation?: boolean;
  contextIsShop?: boolean;
}> = (props) => {
  const [imgData, setImgData] = useState("");
  const [imgCss, setImgCss] = useState("");

  useEffect(() => {
    const getImg = async () => {
      try {
        //console.log("image name ", props.adData);
        const imgObj = convertImgJsonToObj(props.adData.bgImg.imgName);
        console.log("image name ", imgObj.fileName, " end");
        setImgCss(imgObj.imgCss);

        const imgData = await fetchImgThumbnailData(imgObj.fileName);
        setImgData(imgData);
      } catch (e) {
        console.log(e);
      }
    };
    if (
      !!props.adData.bgImg?.imgName &&
      typeof props.adData.bgImg?.imgName === "string"
    ) {
      getImg();
    } else if (props.logoImgData) {
      setImgData(props.logoImgData);
    }
  }, [props.adData, props.logoImgData]);

  const gradients: string[][] = [
    ["#D45BA1", "#A784E0"],
    ["#457739", "#36cfcf"],
    ["#e44f4f", "#F0CB35"],
    ["#3877b6", "#74DAC4"],
    ["#d03857", "#fb6ade"],
    ["#1a5858", "#a0da91"],
  ];
  const gradientIdx = props.idx % gradients.length;
  const gradientA = gradients[gradientIdx][0];
  const gradientB = gradients[gradientIdx][1];

  const titleXLong = props?.adData?.title?.length > 40 ? true : false;
  const titleTooLongSnipSubtext =
    props?.adData?.title?.length > 60 ? true : false;

  const getTextTrimmed = (text: string, charLimit: number) => {
    if (!text) return "";
    const exploreHtml =
      text.length > charLimit
        ? '...<span style="background-color: lightgray; color: gray; padding: 2px 5px; font-size: 0.5rem; margin-left: 5px; border-radius: 5px;">Details</span>'
        : "";
    return `${text.substring(
      0,
      Math.min(charLimit, text.length)
    )}${exploreHtml}`;
  };

  return (
    <>
      <div
        className={`bhp-ad-banner-top`}
        onClick={async () => {
          //trigger the coupon download for the banner clicked
          // await triggerCouponDownload();
          if (props.onClick) props?.onClick();
        }}
      >
        <div
          style={{
            height: "100%",
            width: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            flexShrink: 0,
            // border: "none",
            // borderRight: "2px solid var(--ion-color-medium)",
            // borderTop: "none",
            // borderLeft: "none",
            // borderBottom: "none",
            // borderStyle: "dotted",
          }}
        >
          {/* <BhpSerratedCircle /> */}
          <BhpSerratedCircle
            idx={props.idx}
            radius={35}
            textSize={40}
            gradient={{ colorA: gradientA, colorB: gradientB }}
          />
          {!!props.adData.callToAction && (
            <div className="bhp-ad-call-to-action">
              <div className="bhp-ad-call-to-action-button">
                {props.adData.callToAction}
              </div>
            </div>
          )}
        </div>
        {/* <div className="bhp-ad-img-bg-glow"></div>
        <div className="bhp-ad-img-bg-glow-1"></div>
        <div className="bhp-ad-img-bg-glow-2"></div>
        <div className="bhp-ad-img-bg-glow-3"></div> */}
        {/* <div className={`bhp-ad-img-bg`}>
          <div
            className={`${props?.noRotation ? "" : imgCss}`}
            style={{ height: "100%", width: "100%", overflow: "hidden" }}
          >
            <img className="bhp-ad-img" src={imgData} alt="" loading="lazy" />
          </div>
        </div> */}
        <div className="bhp-ad-text-area">
          {(!!props.adData.shopName || props.contextIsShop) && (
            <div
              className={`bhp-ad-text-area-company`}
              style={{
                background: `linear-gradient(to right, white 0%, ${gradientA} 40%, ${gradientA} 100%)`,
              }}
            >
              {props.contextIsShop && <>Avail Now!</>}
              {!props.contextIsShop && (
                <>
                  {props.adData.shopName.slice(0, 24)}
                  {props.adData.shopName.length > 24 && <>...</>}
                </>
              )}
            </div>
          )}
          <div className="bhp-ad-text-area-text">
            <div
              className="bhp-ad-text-header"
              style={{
                fontSize: !!props.adData?.subTitle
                  ? titleXLong
                    ? "1.1rem"
                    : "1.1rem"
                  : titleXLong
                  ? "1rem"
                  : "1.2rem",
              }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: getTextTrimmed(props.adData.title, 60),
                }}
              />
              {/* {props.adData.title
                ? getTextTrimmed(props.adData.title, 60)
                : "Your Ad Text Will Come Here"} */}
            </div>
            {!!props.adData.subTitle && !titleTooLongSnipSubtext && (
              <div className="bhp-ad-text-subheader">
                <div
                  dangerouslySetInnerHTML={{
                    __html: getTextTrimmed(props.adData.subTitle, 100),
                  }}
                />
              </div>
            )}
          </div>
          {/* <div className="bhp-ad-text-area-button">
            {props?.contextIsShop ? "Avail Now" : "View Details"}
          </div> */}
        </div>
      </div>
    </>
  );
};

export default BhpAdBanner;
